// export const API_URL = "http://localhost:9000";
export const API_URL = "https://translatorapp-server.onrender.com";
export const API_END_POINTS = {
  ADD_TRANSCRIPT: `${API_URL}/addTranscript`,
  GET_TRANSCRIPT: `${API_URL}/getTranscript`,
  DELETE_TRANSCRIPT: `${API_URL}/deleteTranscript`,
};
